<div class="action-header-col action-header-col-max">
    <div class="page-title-row">
        <button
            *ngIf="hasBackButton"
            aum-icon-button
            icon="back"
            color="basic"
            class="no-text"
            size="small"
            [routerLink]="backButtonRoute"
            (keydown.enter)="onBack()"
            (click)="onBack()"
        ></button>
        <h1 *ngIf="pageHeader.isLocalizedKey">{{pageHeader.value | i18next }}</h1>
        <h1 *ngIf="!pageHeader.isLocalizedKey">{{pageHeader.value}}</h1>
    </div>
    <ng-content></ng-content>
</div>
<div class="action-header-col action-col">
    <aum-search
        *ngIf="searchText"
        [placeholder]="searchText | i18next"
        class="search-button"
        size="small"
        [aumFormControl]="searchFormControl"
        (search)="onSearch($event)"
    ></aum-search>
    <button
        *ngIf="filterText"
        aum-icon-button
        icon="filter"
        color="basic"
        size="small"
        class="filter-button"
        (keydown.enter)="onFilter()"
        (click)="onFilter()"
    >
        {{filterText}}
    </button>
    <button
        *ngIf="actionText"
        aum-button
        color="primary"
        size="small"
        class="action-button"
        (keydown.enter)="onNew()"
        (click)="onNew()"
    >
        {{ actionText | i18next}}
    </button>
    <aum-back-forth *ngIf="hasBackForth" size="small" (clickBack)="onUndo()" (clickForth)="onRedo()"></aum-back-forth>
</div>
